import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router';
import * as routes from '../constants/routes';
import { Redirect } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import * as db from '../db/db';
import moment from 'moment'
import TextField from '@material-ui/core/TextField';
import { AppContext } from "../context/applicationContext";
import { withSnackbar } from 'notistack';
import * as statuses from '../constants/requestStatus';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Logo from '../assets/LIREX-logo.png';
import Spinner from '../shared/spinner';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
const env = process.env.NODE_ENV;
const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';


const testWithBuild = 'http://localhost:8080';

const styles = theme => ({
  progress: {
    margin: theme.spacing(2),
    top: '50%!important',
    position: 'absolute'
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    width: 200,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  }, root: {
    flexGrow: 1,
    height: 250,
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2*2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: '24px!important',
    marginBottom: theme.spacing(8),
    padding: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(3*2))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
    background: 'rgb(255 255 255 / 96%)',
  },
  chip: {
    margin: `${theme.spacing() / 2}px ${theme.spacing() / 4}px`,
  },
  inputRoot: {
    flexWrap: 'wrap',
  },
  inputInput: {
    width: 'auto',
    flexGrow: 1,
  },
  divider: {
    height: theme.spacing(2),
  },
  buttons: {
    justifyContent: 'flex-end',
    paddingTop: '42px'
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0),
    width: '100%',
    backgroundColor: '#3a3f4b!important',
    justifyContent: 'center'
  },
  yesButton: {
    marginTop: theme.spacing(5),
    marginLeft: theme.spacing(0),
    width: '100%'
  },
  stepper: {
    padding: `${theme.spacing(3)}px 0 ${theme.spacing(5)}px`,
  },
  element: {
    padding: '10px 40px 0px 40px!important'
  },
  firstElement: {
    padding: '50px 40px 7px 40px!important'
  },
  noPaddingElement: {
    padding: '0px 40px 0px 40px!important',
    marginTop: '-15px'
  },
  paddingElement: {
    padding: '0px 40px 0px 40px!important',
  }
});


class Holiday extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      redirectToEdit: false,
      redirectToHolidaysList: false,
      request: {},
      progress: true,
      requestStatus: null,
      userSite: null,
      userId: null,
      btnDisabled: false,
      onlyView: false,
      redirectToMyHolidays: false,
      redirect: false
    };
  }

  componentDidMount() {
    var url = this.props.match.url;
    if (url.indexOf('View') !== -1) {
      this.setState({ onlyView: true });
    }
    if(this.context.userId){
    db.idbMethods.get(this.context.userId, db.userInfo).then((userInfo) => {
      //this.setState({ userSite: userInfo.userPrimaryCompany.companyURL });
      this.setState({ userId: userInfo.userId });
      var siteUrl;
      if (url.indexOf('View') !== -1) {
        siteUrl = userInfo.userPrimaryCompany.companyURL;
      } else {
        var urlParts = userInfo.userPrimaryCompany.companyURL.split('/');
        siteUrl = userInfo.userPrimaryCompany.companyURL;
        siteUrl = siteUrl.replace(urlParts[urlParts.length - 2], this.props.match.params.siteUrl);
      }
      this.setState({ userSite: siteUrl });
      this.getHolidayData(this.props.match.params.holidayId, siteUrl);
    });
    } else {
      this.logOut();
    }
  }

  getHolidayData = (id, userSite) => {
    const link = baseUrl + `/api/getHoliday`;
    axios.post(link, {
      "HolidayId": id,
      "SiteUrl": userSite,
    }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
      .then(res => {
        this.setState({ request: res.data })
        this.setState({ progress: false });
        this.setState({ requestStatus: res.data.Status });

      }).catch(error => {
        this.setState({ progress: false });
        console.log(error);
        this.logOut();
      })
  }

  redirectToHolidaysList = () => {
    if (this.state.onlyView) {
      this.setState({ redirectToMyHolidays: true });
    } else {
      this.setState({ redirectToHolidaysList: true });
    }
    this.setState({ progress: false });

  }

  redirectToMyHolidays = () => {
    this.setState({ redirectToMyHolidays: true });
  }

  logOut = () => {
    this.context.setStateCustom('userId', null);
    db.idbMethods.clear(db.userInfo);
    db.idbMethods.clear(db.holidaysForApprove);
    db.idbMethods.clear(db.holidaysForApproveList);
    db.idbMethods.clear(db.myHolidays);
    this.setState({ redirect: true });
    //window.location.reload(true);
  }

  submitRequest = () => {
    this.setState({ btnDisabled: true, progress: true });

    let apiUrl = '';
    if (this.state.requestStatus == statuses.FOR_CONFIRM) {
      apiUrl =baseUrl +  '/api/firstLevelApprovement';
    } else if (this.state.requestStatus == statuses.FOR_CONFIRM_REJECT) {
      apiUrl =baseUrl +  '/api/terminationFirstLevel';
    }
    const itemId = this.state.request.Id;
    const link = apiUrl;

    
    axios.post(link,
      {
        'ItemId': itemId,
        'RequestorId': this.state.userId,
        'SiteUrl': this.state.userSite,
        'isAccepted': true,
        'RequestorComment': ""
      }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
      .then(res => {
        if (res.status === 200) {
          this.props.enqueueSnackbar('Заявката за отпуск е одобрена.', { variant: "success" });
          this.setState({ redirectToHolidaysList: true, progress: false });
        }
      }).catch(error => {
        var errorObj = JSON.parse(JSON.stringify(error));
        this.props.enqueueSnackbar('Възникна грешка!', { variant: "error" });
        this.setState({ btnDisabled: false, progress: false });
      })

  }

  rejectRequest = () => {
    this.setState({ btnDisabled: true, progress: true });
    let apiUrl = '';
    if (this.state.requestStatus == statuses.FOR_CONFIRM) {
      apiUrl =baseUrl +  '/api/firstLevelApprovement';
    } else if (this.state.requestStatus == statuses.FOR_CONFIRM_REJECT) {
      apiUrl =baseUrl +  '/api/terminationFirstLevel';
    }
    const link = apiUrl;
    axios.post(link,
      {
        'ItemId': this.state.request.Id,
        'RequestorId': this.state.userId,
        'SiteUrl': this.state.userSite,
        'isAccepted': false,
        'RequestorComment': "."
      }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
      .then(res => {
        if (res.status === 200) {
          this.props.enqueueSnackbar('Заявката за отпуск е отхвърлена успешно', { variant: "success" });
          this.setState({ redirectToHolidaysList: true, progress: false });
        }
      }).catch(error => {
        var errorObj = JSON.parse(JSON.stringify(error));
        this.props.enqueueSnackbar('Възникна грешка!', { variant: "error" });
        this.setState({ btnDisabled: false });
      })
  }



  render() {
    const { classes } = this.props;
    if (this.state.redirect) {
      return <Redirect to={routes.HOME_LOGIN} />
    }
    if (this.state.redirectToHolidaysList) {
      return <Redirect to={routes.HOLIDAYS} />
    }
    if (this.state.redirectToMyHolidays) {
      return <Redirect to={routes.MY_HOLIDAYS} />
    }
    return (

      <React.Fragment>
        {this.state.progress ? <Spinner></Spinner> : null}
        <CssBaseline />
        {/* <AppBar position="absolute" color="default" className={classes.appBar}>
          <Toolbar>
            <Grid container justify="flex-end" spacing={2}>
              <Grid item xs={6}>
                <Typography variant="h6" color="inherit" noWrap>
                  <img className="img-logo" src={Logo} />
                </Typography>
              </Grid>
              <Grid item align="right" xs={6}> */}
                {/* <Button
                  size="small"
                  variant="contained"
                  onClick={() => { this.redirectToMyHolidays() }}
                >
                  Списък
                        </Button> */}
                {/* <Button
                  size="small"
                  variant="contained"
                  onClick={() => { this.logOut() }}
                  className={classes.exitButton + ' backgraound-transperent'}
                >
                  <ExitToApp className='green-circle'></ExitToApp>
                  Изход
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar> */}
        {/* <main className={classes.layout} {`bold-text ${isError ? 'error' : 'success'}`}> */}
        <main className={classes.layout + ` confirmRequest`  + ' header-mrg'}>
          <Paper className={classes.paper}>

            <Typography component="h1" variant="h4" align="center">
            <h4 className='title-custom'>
            {this.state.request.Title || ''}
             </h4>
            </Typography>
           

            <React.Fragment>


            <Grid container spacing={10} >
            <Grid item xs={12} sm={12} className={classes.firstElement}>
                  <TextField
                    id="desc"
                    name="desc"
                    label="Тип на заявката"
                    fullWidth
                    className='confirmRequest'
                    value={this.state.request.TypeRequest || ''}
                  />
                </Grid>

              <Grid item xs={12} sm={12} className={classes.noPaddingElement}>
                  <TextField
                    id="status"
                    className='confirmRequest'
                    name="status"
                    label="Статус"
                    value={this.state.request.Status || ''}
                    fullWidth
                    autoComplete="fname"
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.noPaddingElement}>
                  <TextField
                    id="employeeName"
                    className='confirmRequest'
                    name="employeeName"
                    label="Служител"
                    value={this.state.request.employeeName || ''}
                    fullWidth
                    autoComplete="fname"
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.noPaddingElement}>
                  <TextField
                    id="dateFrom"
                    className='confirmRequest'
                    name="dateFrom"
                    label="От дата"
                    value={moment(this.state.request.DateFrom).format('DD.MM.YYYY') || ''}
                    fullWidth
                    autoComplete="fname"
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.paddingElement}>
                  <TextField
                    id="dateTo"
                    className='confirmRequest'
                    name="dateTo"
                    label="Общо работни дни за отпуск"
                    value={this.state.request.Days || ''}
                    fullWidth
                    autoComplete="fname"
                  />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.element}>
                  <TextField
                    className='confirmRequest'
                    id="replacementName"
                    name="replacementName"
                    label="Заместник"
                    value={this.state.request.replacementName || ''}
                    fullWidth
                    autoComplete="fname"
                  />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.element}>
                  <TextField
                    id="desc"
                    className='confirmRequest'
                    name="desc"
                    label="Тип на отпуската"
                    fullWidth
                    value={this.state.request.Type || ''}
                  />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.element}>
                  <TextField
                    id="desc"
                    className='confirmRequest'
                    name="desc"
                    label="Подтип на отпуската"
                    fullWidth
                    value={this.state.request.SubType || ''}

                  />
                </Grid>
              </Grid>
              <Grid>
                <div className={classes.buttons}>
                  {((this.state.requestStatus == statuses.FOR_CONFIRM || this.state.requestStatus == statuses.FOR_CONFIRM_REJECT) && !this.state.onlyView) ?
                    <span>
                      <Button
                        variant="contained"
                        onClick={() => { this.submitRequest() }}
                        className={classes.button + ' success-btn'}
                        disabled={this.state.btnDisabled}
                      >
                        <Check className='white-back-button'></Check>
                        <span btn-content>ДА</span>
                    </Button>

                      <Button
                        variant="contained"
                        onClick={this.rejectRequest}
                        className={classes.button + ' denied-btn'}
                        disabled={this.state.btnDisabled}
                      >
                        <Clear className='white-back-button'></Clear>
                        <span btn-content>НЕ</span>                        
                    </Button>
                    </span>
                    : null}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.redirectToHolidaysList}
                    className={classes.button}
                    disabled={this.state.btnDisabled}
                  >
                    <ArrowBackIos className='white-back-button'></ArrowBackIos>
                    <span btn-content>НАЗАД</span>
                    </Button>
                </div>
              </Grid>
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    )
  }
}

Holiday.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(withSnackbar(Holiday)));